var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.893 10.723L12 7.616l3.109 3.109 1.808-1.808L12 4 7.085 8.915l1.808 1.808zM4 12l1.808-1.808L7.616 12l-1.808 1.808L4 12zm4.893 1.277L12 16.384l3.109-3.109 1.808 1.807L12 20l-4.915-4.915-.003-.003 1.81-1.805zM16.384 12l1.808-1.808L20 12l-1.808 1.808L16.384 12zm-2.549-.002V12L12 13.835l-1.833-1.832-.003-.003.003-.002.321-.322.156-.156L12 10.165l1.835 1.833z",
    fill: "#fff"
  })));
}
export default SvgBinance;